import styled from '@emotion/styled/macro';

export const CountdownWrapper = styled.div`
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    align-items: center;
    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.15);
    padding: ${props => props.theme.spacing.large}
        ${props => props.theme.spacing.normal};
`;

export const DateTimeHeader = styled.span`
    text-align: center;
    color: ${props => props.theme.colours.black};
    font-family: ${props => props.theme.fonts.gtWalsheimPro};
    font-size: ${props => props.theme.fontSize.normal};
`;

export const Title = styled.span`
    text-transform: uppercase;
    text-align: center;
    color: ${props => props.theme.colours.textGreen};
    font-family: ${props => props.theme.fonts.gtWalsheimProBold};
    font-size: ${props => props.theme.fontSize.large};
    font-weight: 700;
    padding-top: ${props => props.theme.spacing.normal};
`;

export const TimeWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding-top: ${props => props.theme.spacing.large};
`;

export const TimeUnitWrapper = styled.div`
    display: flex;
    justify-content: space-evenly;
    align-items: flex-end;
`;

export const TimeUnit = styled.div`
    padding: 0 ${props => props.theme.spacing.xsmall} 0
        ${props => props.theme.spacing.small};
    color: ${props => props.theme.colours.textOrange};
    font-family: ${props => props.theme.fonts.digital};
    font-size: ${props => props.theme.fontSize.medium};
`;

export const TimeUnitDescription = styled.div`
    padding: 0 ${props => props.theme.spacing.small} 0 0;
    color: ${props => props.theme.colours.textDark};
    font-family: ${props => props.theme.fonts.gtWalsheimProMedium};
    font-size: ${props => props.theme.fontSize.medium};
    line-height: ${props => props.theme.lineHeight.xsmall};
`;
